import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {FormItemComponentInterface} from '../../../../interface/component';
import {IFormItemsControls} from '../../../../interface/form-structure';

@Component({
    selector: 'noos-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss']
})
@NoosFormTypeService.register('file')
export class FileUploadComponent implements OnInit, AfterViewInit, FormItemComponentInterface {


    prop: IFormItemsControls;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    constructor() {
    }

    ngOnInit() {
    }


    ngAfterViewInit(): void {
    }

    selectFile(files: FileList) {
        const file: File = files.item(0);

        if (files && file) {
            const myReader: FileReader = new FileReader();
            myReader.onloadend = (e) => {
                this.prop.defaultValue = myReader.result;
            };
            myReader.readAsDataURL(file);
            this.prop.defaultValueTitle = file.name;
        }
    }


    fileChangeEvent(fileInput: any) {

        console.log('fileInput:', fileInput);

        if (fileInput.target.files && fileInput.target.files[0]) {
            const reader = new FileReader();
            reader.onloadend = (e) => {
                this.prop.defaultValue = reader.result;
                console.log('reader:', reader.result);
            };
            reader.readAsDataURL(fileInput.target.files[0]);
            this.prop.defaultValueTitle = fileInput.target.files[0].name;
            console.log('File:', fileInput.target.files[0]);
            console.log('Prop:', this.prop);
        }
    }
}
